export interface ApiErrorOptions<TPayload = unknown> {
  readonly status: number;
  readonly code?: string | null;
  readonly payload?: TPayload;
}

export class ApiError<TPayload = unknown> extends Error {
  readonly status: number;
  readonly code: string | null;
  readonly detail: string;
  readonly payload: TPayload | undefined;

  constructor(detail: string, options: ApiErrorOptions<TPayload>) {
    super(detail);
    this.name = 'ApiError';
    this.status = options.status;
    this.code = options.code ?? null;
    this.detail = detail;
    this.payload = options.payload;
  }
}

export class ApiProtocolError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'ApiProtocolError';
  }
}
